export default "__VITE_ASSET__UVVWWnAL__"